export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        query: {
            type: String,
            required: true,
        },
        isGrid: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            searchItem: {},
        };
    },
    created() {
        this.searchItem = this.item;
    },
    mounted() {
        this.markMatches();
    },
    methods: {
        markMatches() {
            const matches = this.findMatches();
            matches.forEach((classes) => {
                const el = this.$el.querySelector(`.${classes.replaceAll('.', '-')}`);
                if (!el) return;
                el.querySelector('span').classList.add('colored');
            });
        },
        findMatches() {
            const matches = [];
            const fields = this.extractItemData();
            const searchStrings = this.modifyQuery().filter((x) => x !== '');
            Object.keys(fields).forEach((field) => {
                let text = _.get(fields, field);
                if (_.isBoolean(text) || _.isNull(text)) return;
                if (_.isNumber(text)) text = text.toString();
                searchStrings.forEach((search) => {
                    if (_.includes(text, search)) {
                        matches.push(field);
                    }
                });
            });
            return [...new Set(matches)];
        },
        modifyQuery() {
            const search = [];
            const query = this.query;
            let queryWords = [];
            if (_.includes(query, ' ')) {
                queryWords = query.split(' ');
            }

            if (_.includes(query, '-')) {
                queryWords = query.split('-');
            }

            if (_.includes(query, '.')) {
                queryWords = query.split('.');
            }

            if (_.includes(query, '/')) {
                queryWords = query.split('/');
            }

            queryWords.forEach((word) => {
                if (_.isNumber(parseInt(word)) && word.length === 1) word = '0' + word.toString();
                search.push(_.upperFirst(_.lowerCase(word)));
                search.push(_.lowerCase(word));
                search.push(_.upperCase(word));
                search.push(word);
            });
            return search;
        },
        extractItemData() {
            const data = {};
            Object.keys(this.item).forEach((key) => {
                if (key !== 'data') {
                    data[key] = this.item[key];
                }
                if (!this.item.data) {
                    return;
                }
                Object.keys(this.item.data).forEach((key) => {
                    if (_.isObject(_.get(this.item.data, key))) {
                        Object.keys(_.get(this.item.data, key)).forEach((childKey) => {
                            data[`data.${key}.${childKey}`] = _.get(_.get(this.item.data, key), childKey);
                        });
                        return;
                    }
                    if (key == 'birth_date') {
                        const date = _.get(this.item.data, key);
                        const dates = [];
                        dates.push(date);
                        dates.push(_.reverse(date.split('-')).join('-'));
                        dates.push(moment(date).format(this.$root.dateFormat));
                        dates.push(date.split('-').join('.'));
                        data[`data.${key}`] = dates.join(' ');
                        return;
                    }
                    data[`data.${key}`] = _.get(this.item.data, key);
                });
            });
            return data;
        },
    },
};
